import { Suspense, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { TrackingEvents, useTrackingDispatch } from 'modules/analytics';
import { Layout } from 'modules/minimal-ui-theme';
import { ModalName, useModal } from 'modules/modal';
import {
  LazyAddReasonErrorAlert,
  LazyAddReasonModal,
  LazyAddReasonSuccessToast,
  LazyAddShiftErrorAlert,
  LazyAddShiftModal,
  LazyAddShiftSuccessToast,
  LazyCloseWeekErrorAlert,
  LazyCloseWeekModal,
  LazyCloseWeekSuccessToast,
  LazyDeleteReasonSuccessToast,
  LazyDeleteShiftSuccessToast
} from 'modules/modals';
import { WeekDetails, WeekDetailsHeader } from 'modules/week-details';

export const WeekDetailsPage = () => {
  const dispatch = useTrackingDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { weekId } = useParams();
  const { open } = useModal();

  useEffect(() => {
    dispatch({
      type: TrackingEvents.WEEK_DETAILS_PAGE_VIEWED
    });
  }, [dispatch]);

  // Opened from the home hero's Finish/Add buttons: run the same verified flow here.
  useEffect(() => {
    const autoOpen = (location.state as { autoOpen?: string } | null)?.autoOpen;
    if (autoOpen === 'closeWeek') {
      open(ModalName.closeWeek);
      // Consume the intent so returning to this route doesn't re-open it.
      navigate(`${location.pathname}${location.search}`, { replace: true });
    } else if (autoOpen === 'addShift' && weekId) {
      // AddShiftModal opens itself from this same intent (StrictMode-safe).
      dispatch({
        type: TrackingEvents.INIT_SHIFT,
        payload: { id: uuidv4(), weekId }
      });
    }
    // Mount-only: consume the navigation intent once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout header={<WeekDetailsHeader />}>
      <WeekDetails />
      <Suspense>
        <LazyAddShiftErrorAlert />
        <LazyAddShiftModal />
        <LazyAddShiftSuccessToast />
        <LazyAddReasonSuccessToast />
        <LazyAddReasonErrorAlert />
        <LazyCloseWeekModal />
        <LazyCloseWeekSuccessToast />
        <LazyCloseWeekErrorAlert />
        <LazyAddReasonModal />
        <LazyDeleteShiftSuccessToast />
        <LazyDeleteReasonSuccessToast />
      </Suspense>
    </Layout>
  );
};
